import { createUseStyles } from "react-jss";

export const BubbleStyle = createUseStyles((theme: any) => ({
    bubble: {
        color: "orange",
        position: "absolute",
    },
}));
